// Generated by scripts/gen-exercise-ids.mjs. Do not edit by hand.
// Re-run with: npm run gen:ids

const _EXERCISE_IDS = {
  "bridge-1": "exbr0102710c42e",
  "bridge-10": "exbr10a99cd8cf6",
  "bridge-2": "exbr02557ecbebf",
  "bridge-3": "exbr030d5df1c4c",
  "bridge-4": "exbr04039570f8d",
  "bridge-5": "exbr05d6285251f",
  "bridge-6": "exbr067e763ec58",
  "bridge-7": "exbr07595a729bc",
  "bridge-8": "exbr0843f1f1c25",
  "bridge-9": "exbr094c9c8ef66",
  "front_lever-1": "exfl015186b2a51",
  "front_lever-2": "exfl024f71ff290",
  "front_lever-3": "exfl0301633b993",
  "front_lever-4": "exfl0470b0c5341",
  "handstand_pushup-1": "exhs0135351fd20",
  "handstand_pushup-10": "exhs10e767ee64e",
  "handstand_pushup-2": "exhs02028f98428",
  "handstand_pushup-3": "exhs03a53b326b9",
  "handstand_pushup-4": "exhs04a70cd6f5d",
  "handstand_pushup-5": "exhs0581a3fe4eb",
  "handstand_pushup-6": "exhs06637bc2b26",
  "handstand_pushup-7": "exhs07c9485544a",
  "handstand_pushup-8": "exhs08b0d6de2df",
  "handstand_pushup-9": "exhs09dc998ffdc",
  "human_flag-1": "exhf01393cc9336",
  "human_flag-2": "exhf02661b94e02",
  "human_flag-3": "exhf036bfa6dc43",
  "l_sit-1": "exls016aa7d6cfb",
  "l_sit-2": "exls02c1a021aeb",
  "l_sit-3": "exls03d54975100",
  "leg_raise-1": "exlr0132f5b79c8",
  "leg_raise-10": "exlr10b24dab2b1",
  "leg_raise-2": "exlr02f8a16ad25",
  "leg_raise-3": "exlr03f6e11b0a1",
  "leg_raise-4": "exlr04dbb504b1c",
  "leg_raise-5": "exlr054ffe67441",
  "leg_raise-6": "exlr06095ae2fd8",
  "leg_raise-7": "exlr071ada61f1c",
  "leg_raise-8": "exlr08e7cd87326",
  "leg_raise-9": "exlr09418076526",
  "muscle_up-1": "exmu01800db243f",
  "muscle_up-2": "exmu022dfbecc54",
  "muscle_up-3": "exmu03d44cfa4e4",
  "planche-1": "expc01ef0bedb0f",
  "planche-2": "expc02d1c23e76d",
  "planche-3": "expc035e04b4ff8",
  "planche-4": "expc04ce461c9c4",
  "pullup-1": "expl0176e4bd823",
  "pullup-10": "expl109e4000878",
  "pullup-2": "expl02512dcacaa",
  "pullup-3": "expl0363b7d6f6a",
  "pullup-4": "expl04fcc165e17",
  "pullup-5": "expl05aba58b5d6",
  "pullup-6": "expl066762ad13e",
  "pullup-7": "expl072fbfc6270",
  "pullup-8": "expl0885ab07010",
  "pullup-9": "expl0991d55ce6f",
  "pushup-1": "expu01ecaefa595",
  "pushup-10": "expu106252ef8e6",
  "pushup-2": "expu025c8dd7278",
  "pushup-3": "expu037593ee452",
  "pushup-4": "expu04c1034162d",
  "pushup-5": "expu05445048000",
  "pushup-6": "expu0659e974e79",
  "pushup-7": "expu07bdb9acebb",
  "pushup-8": "expu08f8710213e",
  "pushup-9": "expu091c980154d",
  "squat-1": "exsq01667df69d1",
  "squat-10": "exsq10717712d98",
  "squat-2": "exsq029f3d7ad60",
  "squat-3": "exsq03dcf7f1be2",
  "squat-4": "exsq04ba7bb9299",
  "squat-5": "exsq05610c741bd",
  "squat-6": "exsq06b326164f2",
  "squat-7": "exsq072004eaf66",
  "squat-8": "exsq08f39f48a55",
  "squat-9": "exsq0908bb5a06f",
} as const;

export const EXERCISE_IDS: Record<string, string> = _EXERCISE_IDS;

export type ExerciseSlug = keyof typeof _EXERCISE_IDS;
